<template>
  <div class="page">
    <!-- 搜索 -->
    <el-form
      v-if="isSearch"
      :model="queryForm"
      ref="form"
      label-width="80px"
      :inline="true"
      size="small"
      class="query-form"
      @submit.native.prevent
    >
      <el-form-item label="文章名称">
        <el-input
          v-model="queryForm.articleName"
          placeholder="请填写文章名称"
          style="width: 180px"
        ></el-input>
      </el-form-item>
      <el-form-item label="文章作者">
        <el-input
          v-model="queryForm.articleAuthor"
          placeholder="请填写文章作者"
          style="width: 180px"
        ></el-input>
      </el-form-item>
      <el-form-item label="是否显示">
        <el-select
          placeholder="请选择是否显示"
          clearable
          style="width: 180px"
          size="small"
          v-model="queryForm.isShow"
        >
          <el-option
            label="是"
            :value="1"
          >
          </el-option>
          <el-option
            label="否"
            :value="0"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="文章分类">
        <el-select
        style="width: 180px"
          v-model="queryForm.catalogId"
          placeholder="请选择文章分类"
          clearable
          size="small"
        >
          <el-tree
            default-expand-all
            :data="catalog"
            :props="treeProps"
          >
            <div
              class="custom-tree-node flex items-center"
              slot-scope="{ node, data }"
            >
              <el-option
                :label="node.label"
                :value="data.id"
              > </el-option>
            </div>
          </el-tree>
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间">
        <el-date-picker
          placeholder="请选择创建时间"
          clearable
          v-model="createTime"
          style="width: 180px"
          type="datetimerange"
          size="small"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="-"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item style="margin-left: 80px">
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="getCmsArticleList"
        >查询</el-button>
        <el-button
          size="small"
          icon="el-icon-refresh"
          @click="resetDialog"
        >重置</el-button>
      </el-form-item>
    </el-form>
    <div class="page-content">
      <div class="page-tool-bar">
        <div class="el-btn-group">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click="addCmsArticle"
          >新建</el-button>
          <el-button
            type="warning"
            plain
            size="small"
            icon="el-icon-edit"
            :disabled="multipleSelection.length != 1"
            @click="editCmsArticle(null)"
          >修改</el-button>
          <el-button
            type="danger"
            plain
            size="small"
            icon="el-icon-delete"
            :disabled="multipleSelection.length <= 0"
            @click="deleteCmsArticle(null)"
          >删除</el-button>
            <el-button
                type="primary"
                size="small"
                @click="openIsShow"
            >文章目录管理</el-button>
        </div>

        <div class="icon-group">
          <span
            title="搜索"
            class="icon-box"
            @click="search"
          >
            <Icon color="#606266">
              <Search />
            </Icon>
          </span>

          <span
            class="icon-box"
            @click="refreshCmsArticleList"
          >
            <Icon color="#606266">
              <Refresh />
            </Icon>
          </span>
        </div>
      </div>
      <!-- 列表数据 -->
      <el-table
        :data="cmsArticleList"
        size="small"
        height="100%"
        row-key="id"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          align="center"
          type="selection"
          min-width="10%"
        > </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="articleName"
          label="文章名称"
          min-width="12%"
        >
        </el-table-column>

        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="catalog.catalogName"
          label="文章分类"
          min-width="12%"
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="是否显示"
          min-width="12%"
        >
          <template slot-scope="scop">
            <el-switch
              :value="true"
              active-color="#13ce66"
              inactive-color="#ff4949"
              v-if="scop.row.isShow == 1"
              @change="toggleArticleIsShow(scop.row)"
            >
            </el-switch>
            <el-switch
              :value="false"
              active-color="#13ce66"
              inactive-color="#ff4949"
              v-if="scop.row.isShow == 0"
              @change="toggleArticleIsShow(scop.row)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="articlePic"
          label="图片"
          min-width="12%"
        >
          <template slot-scope="scope">
              <div v-if='scope.row.articlePic'>
                  <el-image
                      @click='updateSrcList(scope.row.articlePic)'
                      style="width: 30px; height: 30px"
                      :src="scope.row.articlePic"
                      :preview-src-list="srcList"
                  > </el-image>
              </div>
              <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="articleAuthor"
          label="作者"
          min-width="10%"
        >
        </el-table-column>
          <el-table-column
              align="center"
              label="排序"
              min-width="20%"
          >
              <template slot-scope="scop">
                  <el-input-number
                      style="width:120px"
                      v-model="scop.row.sort"
                      @change="toggleArticleIsSort(scop.row)"
                      size="small"
                      label=""
                      :min="1"
                      :max="1000"
                      :step="10"
                      :controls="true"
                      controls-position="both"
                  >
                  </el-input-number>
              </template>
          </el-table-column>
        <el-table-column
          align="center"
          prop="createTime"
          label="添加时间"
          min-width="20%"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="id"
          label="文章ID"
          min-width="20%"
        >
        </el-table-column>

        <el-table-column
          align="center"
          label="操作"
          min-width="25%"
        >
          <template slot-scope="scop">
            <div class="operation">
              <div @click="checkCmsArticle(scop.row.id)">
                <Icon size="16">
                  <Eye24Regular />
                </Icon>
                <span class="operation-label">查看</span>
              </div>
              <div @click="editCmsArticle(scop.row.id)">
                <Icon size="16">
                  <Edit24Regular />
                </Icon>
                <span class="operation-label">修改</span>
              </div>
              <div
                @click="deleteCmsArticle(scop.row.id)"
                style="color: red"
              >
                <Icon size="16">
                  <Delete24Regular />
                </Icon>
                <span class="operation-label">删除</span>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          background
          :pager-count="7"
        >
        </el-pagination>
      </div>
      <!-- 新增/查看/修改信息 -->
      <el-dialog
        :title="cmsArticleStates[cmsArticleState]"
        :visible.sync="showDialog"
        width="80%"
        @close="closeDialog"
      >
        <div>
          <el-form
            :model="cmsArticle"
            ref="cmsArticleForm"
            :rules="rules"
            label-width="80px"
            :inline="true"
            size="mini"
          >
            <el-tabs type="border-card">
              <el-tab-pane>
                <span slot="label"><i class="fa fa-navicon"></i> 基本信息</span>
                <el-scrollbar style="height: 350px">
                  <el-form-item
                    label="文章名称"
                    prop="articleName"
                  >
                    <el-input
                    style="width: 200px"
                      size="small"
                      v-model="cmsArticle.articleName"
                      :disabled="cmsArticleState == 'check'"
                    ></el-input>
                  </el-form-item>

                  <el-form-item
                    label="所属目录"
                    prop="catalogId"
                  >
                    <el-select
                    style="width: 200px"
                      v-model="cmsArticle.catalogId"
                      placeholder="请选择文章分类"
                      :disabled="cmsArticleState == 'check'"
                      clearable
                      size="small"
                    >
                      <el-tree
                        default-expand-all
                        :data="catalog"
                        :props="treeProps"
                      >
                        <div
                          class="custom-tree-node flex items-center"
                          slot-scope="{ node, data }"
                        >
                          <el-option
                            :label="node.label"
                            :value="data.id"
                          > </el-option>
                        </div>
                      </el-tree>
                    </el-select>
                  </el-form-item>

				  <el-form-item
				    label="是否显示"
				    prop="isShow"
				  >
				    <el-select
				      style="width: 200px"
				      v-model="cmsArticle.isShow"
				      :disabled="cmsArticleState == 'check'"
				    >
				      <el-option
				        v-for="isShow in isShowList"
				        :key="isShow.key"
				        :label="isShow.value"
				        :value="isShow.key"
				      >
				      </el-option>
				    </el-select>
				  </el-form-item>

                  <el-form-item
                    label="作者"
                    prop="articleAuthor"
                  >
                    <el-input
                      size="small"
                      style="width: 200px"
                      v-model="cmsArticle.articleAuthor"
                      :disabled="cmsArticleState == 'check'"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="来源"
                    prop="articleSource"
                  >
                    <el-input
                    style="width: 200px"
                      size="small"
                      v-model="cmsArticle.articleSource"
                      :disabled="cmsArticleState == 'check'"
                    ></el-input>
                  </el-form-item>


                    <el-form-item
                        label="链接"
                        prop="articleLink"
                    >
                        <el-input
                            size="small"
                            style="width: 200px"
                            v-model="cmsArticle.articleLink"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        align="center"
                        label="排序"
                    >

                        <el-input-number
                            style="width:200px"
                            v-model="cmsArticle.sort"
                            :disabled="cmsArticleState == 'check'"
                            size="small"
                            label=""
                            :min="1"
                            :max="10000"
                            :step="10"
                            :controls="true"
                            @change="editChangeSort"
                            controls-position="both"
                        >
                        </el-input-number>
                    </el-form-item>

                  <el-form-item
                    label="图片"
                    prop="articlePic"
                  >
                    <el-upload
                      action=""
                      :disabled="cmsArticleState == 'check'"
                      class="avatar-uploader"
                      :show-file-list="false"
                      :http-request="uploadImage"
                    >
                      <img
                        v-if="cmsArticle.articlePic"
                        :src="cmsArticle.articlePic"
                        class="avatar"
                        size="small"
                      />
                      <i
                        v-else
                        class="el-icon-plus avatar-uploader-icon"
                      ></i>
                    </el-upload>
                  </el-form-item>
                </el-scrollbar>
              </el-tab-pane>
              <el-tab-pane>
                <span slot="label"><i class="fa fa-database"></i> 内容信息</span>
                <el-scrollbar style="height: 350px">
                  <el-form-item
                    label="概要"
                    prop="articleSummary"
                  >
                    <el-input
                      type="textarea"
                      :rows="3"
                      style="width:820px"
                      placeholder="请输入概要"
                      v-model="cmsArticle.articleSummary"
                    >
                    </el-input>

                  </el-form-item>
                  <el-form-item
                    label="内容"
                    prop="articleContent"
                  >
                    <WangEditor
                      ref="contentEditor"
                      v-model="cmsArticle.articleContent"
                    />
                  </el-form-item>
                </el-scrollbar>
              </el-tab-pane>
              <el-tab-pane>
                <span slot="label"><i class="fa fa-chrome"></i> 其他信息</span>
                <el-scrollbar style="height: 350px">

                  <el-form-item
                    label="标题"
                    prop="articleTitle"
                  >
                    <el-input
                      size="small"
                      v-model="cmsArticle.articleTitle"
                      :disabled="cmsArticleState == 'check'"
                      style = "width:200px"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="关键字"
                    prop="articleKeywords"
                  >
                    <el-input
                      size="small"
                      v-model="cmsArticle.articleKeywords"
                      :disabled="cmsArticleState == 'check'"
                      style = "width:200px"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="描述"
                    prop="articleDescription"
                  >
                    <el-input
                      size="small"
                      v-model="cmsArticle.articleDescription"
                      :disabled="cmsArticleState == 'check'"
                      style = "width:200px"
                    ></el-input>
                  </el-form-item>

				  <el-form-item
				    label="SEO标签"
				    prop="tags"
				  >
				    <el-input
				      size="small"
				      v-model="cmsArticle.tags"
				      :disabled="cmsArticleState == 'check'"
				      style = "width:200px"
				    ></el-input>
				  </el-form-item>

                </el-scrollbar>
              </el-tab-pane>
            </el-tabs>

          </el-form>
        </div>

        <div
          slot="footer"
          class="flex justify-end"
        >
          <el-button @click="closeDialog">关闭</el-button>
          <el-button
            type="primary"
            @click="submitForm"
            v-if="cmsArticleState != 'check'"
          >确定</el-button>
        </div>
      </el-dialog>
    </div>
      <el-drawer
      title="文章目录管理"
      :visible.sync="isShow"
      direction="rtl"
      size="70%"
      :before-close="closeIsShow">
      <CatalogList ref='cmsArticleCategory'></CatalogList>
  </el-drawer>
  </div>
</template>

<script>
// import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular, ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import WangEditor from '@/components/common/wangeditor';
import CatalogList from '@/components/cms/CatalogList.vue';

export default {
    components: {
        Edit24Regular,
        CatalogList,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        WangEditor
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetCmsArticleList();
                this.getCmsArticleList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetCmsArticleList();
                this.getCmsArticleList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            queryForm: {
                articleName: '', //名称
                startTime: '', //开始时间
                endTime: '', //结束时间
                articleAuthor: '', //作者
                catalogId: '', //文章分类id
                isShow: '' //是否显示
            },
            srcList:[''],//大图预览
            createTime: [], //创建时间
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            cmsArticleState: 'add',
            cmsArticleStates: {
                add: '新建文章',
                check: '查看文章',
                edit: '修改文章'
            },

            multipleSelection: [],
            cmsArticleList: [],
            cmsArticle: {
                id: '', //ID
                articleName: '', //名称
                articleContent: '', //内容
                articleSummary: '', //概要
                articleAuthor: '', //作者
                articleLink:'',//链接
                sort: '1',
                articleSource: '', //来源
                articlePv: '', //访问次数
				articleUv: '', //访客数
                articlePic: '', //图片
                catalogId: '', //文章分类id
                catalog: {},
                isShow: '', //是否显示
                tags: '', //SEO标签
                articleTitle: '', //SEO标题
                articleKeywords: '', //SEO关键字
                articleDescription: '', //SEO描述
            },
            btnLoading: false,

            rules: {
                articleName: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
                //articleAuthor: [{ required: true, message: '作者不能为空', trigger: 'blur' }],
                //articleSource: [{ required: true, message: '来源不能为空', trigger: 'blur' }],
                //articlePic: [{ required: true, message: '图片不能为空', trigger: 'blur' }],
                catalogId: [{ required: true, message: '文章分类不能为空', trigger: 'blur' }],
                isShow: [{ required: true, message: '是否显示不能为空', trigger: 'blur' }],
                sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }]
            },
            catalog: {},
            treeProps: {
                children: 'children',
                label: 'catalogName'
            },
            isShowList: [],

            isShow: false,
        };
    },

    created() {
        this.getCmsArticleList();
        this.getCatalog(); //获取所有文章的目录
        this.getIsShowList();
    },
    methods: {
        search() {
            this.isSearch = !this.isSearch;
        },
        openIsShow(){
            this.isShow = true;
            this.$nextTick(()=>{
                this.$refs.cmsArticleCategory.init()
            })
        },
        closeIsShow(){
            this.isShow = false;
            this.refreshCmsArticleList();
            this.getCatalog();
        },
        resetCmsArticleList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.cmsArticleList = [];
        },
        resetDialog() {
            this.cmsArticleState = 'add';
            this.showDialog = false;
            this.queryForm = {
                articleName: '', //名称
                startTime: '', //开始时间
                endTime: '', //结束时间
                articleAuthor: '', //作者
                catalogId: '', //文章分类id
                isShow: '' //是否显示
            };
            this.createTime = [];
            this.getCmsArticleList();
        },
        closeDialog() {
           this.cmsArticle = {
                id: '', //ID
                articleName: '', //名称
                articleContent: '', //内容
                articleSummary: '', //概要
                articleAuthor: '', //作者
                articleSource: '', //来源
                articlePv: '', //访问次数
				articleUv: '', //访客数
                articlePic: '', //图片
                catalogId: '', //文章分类id
                catalog: {},
                isShow: '', //是否显示
                tags: '', //SEO标签
                articleTitle: '', //SEO标题
                articleKeywords: '', //SEO关键字
                articleDescription: '', //SEO描述
            };
            this.$refs.contentEditor.init('');
            this.showDialog = false;
        },
        submitForm() {
            if (this.cmsArticleState == 'add') {
                this.$refs.cmsArticleForm.validate((valid) => {
                    if (valid) {
                        post(`/cms/article/add`, { ...this.cmsArticle }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetCmsArticleList();
                                this.resetDialog();
                                this.getCmsArticleList();
                            }
                        });
                    }
                });
            } else if (this.cmsArticleState == 'edit') {
                this.$refs.cmsArticleForm.validate((valid) => {
                    if (valid) {
                        delete this.cmsArticle.catalog;
                        post(`/cms/article/edit`, { ...this.cmsArticle }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.cmsArticleState = 'add';
                                this.showDialog = false;
                                this.getCmsArticleList();
                            }
                        });
                    }
                });
            }
        },
        addCmsArticle() {
            this.showDialog = true;
            this.cmsArticleState = 'add';
        },
        checkCmsArticle(cmsArticleId) {
            this.currentCmsArticleId = cmsArticleId;
            this.getCmsArticleById();
            this.showDialog = true;
            this.cmsArticleState = 'check';
        },
        editCmsArticle(cmsArticleId) {
            console.log(cmsArticleId)
            if (cmsArticleId) {
                this.currentCmsArticleId = cmsArticleId;
                this.getCmsArticleById();
            } else {
                this.cmsArticle = { ...this.cmsArticle, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.cmsArticleState = 'edit';
        },
        deleteCmsArticle(cmsArticleId) {
            let ids = '';
            if (cmsArticleId) {
                ids = cmsArticleId;
            } else {
                ids = this.multipleSelection.map((cmsArticle) => cmsArticle.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/cms/article/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetCmsArticleList();
                            this.getCmsArticleList();
                        }
                    });
                })
                .catch(() => {});
        },
        refreshCmsArticleList() {
            this.resetCmsArticleList();
            this.getCmsArticleList();
        },
        getCmsArticleList(query = {}) {
            this.loading = true;
            if (this.createTime != null) {
                this.queryForm.startTime = this.createTime[0];
                this.queryForm.endTime = this.createTime[1];
            }
            get(`/cms/article/findList`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.cmsArticleList = res.page.list;
                    this.totalNum = res.page.total;
                }
            });
        },
        getCmsArticleById() {
            this.cmsArticle = {};
            this.loading = true;
            get(`/cms/article/get`, { id: this.currentCmsArticleId }).then((res) => {
              this.$refs.contentEditor.init('');
                if (res.success) {
                    this.cmsArticle = { ...this.cmsArticle, ...res.cmsArticle };
                    this.$refs.contentEditor.init(this.cmsArticle.articleContent);
                    this.loading = false;
                }
            });
        },
        /**
         * 导出出岗位信息
         */
        exportCmsArticleList() {
            this.btnLoading = true;
            exprotExcel(`/cms/cmsarticle/export`, this.cmsArticle, this.btnLoading);
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/cms/article/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/cms/article/importData`, formData);
            this.refreshCmsArticleList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getCmsArticleList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getCmsArticleList();
        },
        toggleArticleIsShow(article) {

            //修改isShow时富文本传输有问题，在此处移除富文本相关
            delete article.articleContent
            delete article.articleSummary

            delete article.catalog;
            post('/cms/article/edit', { ...article, isShow: article.isShow == 1 ? 0 : 1 }).then((res) => {
                if (res.success) {
                    this.$message({
                        message: `编辑成功`,
                        type: 'success',
                        duration: 2000
                    });
                    this.resetCmsArticleList();
                    this.getCmsArticleList();
                }
            });
        },
        toggleArticleIsSort(article) {

            //修改isSort时富文本传输有问题，在此处移除富文本相关
            delete article.articleContent
            delete article.articleSummary

            delete article.catalog;
            post('/cms/article/edit', { ...article}).then((res) => {
                if (res.success) {
                    this.$message({
                        message: `编辑成功`,
                        type: 'success',
                        duration: 2000
                    });
                    this.resetCmsArticleList();
                    this.getCmsArticleList();
                }
            });
        },
        changeArticleIsShow(isshow) {
            console.log(isshow);
            if (isshow == 1) {
                this.cmsArticle.isShow = 0;
            } else {
                this.cmsArticle.isShow = 1;
            }
        },
        getCatalog() {
            get('/cms/catalog/findAllAsTree', {}).then((res) => {
                if (res.success) {
                    this.catalog = res.catalog;
                }
            });
        },
        uploadImage(params) {
            const file = params.file;
            let types = ['image/jpeg', 'image/png', 'image/jpg'];
            if (!types.includes(file.type)) {
                this.$message({
                    message: '只能上传图片格式的文件，png.jpg或者jpeg',
                    type: 'error',
                    showClose: true,
                    duration: 2000
                });
            }
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            upload('/mpp/image/upload', formData).then((res) => {
                console.log(res);
                if (res.success) {
                    this.cmsArticle.articlePic = res.url;
                }
            });
        },
        //是否上架
        getIsShowList() {
            get(`/mpp/utils/getEnum`, { enumType: `yes_no` }).then((res) => {
                if (res.success) {
                    this.isShowList = res.enumList;
                }
            });
        },


        editChangeSort(e) {
            console.log(e);
            this.cmsArticle.sort = e;
        },

        updateSrcList(src){
            this.srcList[0] = src
        }

        // changeSort(catalog) {
        //     console.log(catalog);
        //     if (!catalog.parentId) {
        //         delete catalog.children;
        //     }
        //     delete catalog.children;
        //     post(`/cms/article/edit`, { ...catalog }).then((res) => {
        //         if (res.success) {
        //             this.$message({
        //                 message: `编辑成功`,
        //                 type: 'success',
        //                 duration: 2000
        //             });
        //             this.refreshCmsArticleList()();
        //         }
        //     });
        // },
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 200px;
    height: 200px;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 200px;
    text-align: center;
}
.avatar {
    width: 200px;
    height: 200px;
    display: block;
}
</style>
